import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportInvitesExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Manage Invites");
  const t = i18n.t.bind(i18n);
  const formatSubscription = (value) => {
  if (!value) return "";
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

  // Define columns with headers
  worksheet.columns = [
    { header: t("invites.columns.id"), key: "id", width: 10 },
    { header: t("invites.columns.admin"), key: "admin", width: 20 },
    { header: t("invites.columns.email"), key: "email", width: 30 },
    { header: t("invites.columns.company"), key: "company", width: 25 },
    { header: t("invites.columns.country"), key: "country", width: 15 },
    { header: t("invites.columns.subscription"), key: "subscription", width: 15 },
    { header: t("invites.columns.status"), key: "status", width: 12 },
    { header: t("invites.columns.verificationStatus"), key: "verificationStatus", width: 20 },
    { header: t("invites.columns.date"), key: "date", width: 25 },
  ];
  // Format subscription before inserting
  const formattedData = data.map((item) => ({
    ...item,
    subscription: item.subscription
      ? formatSubscription(item.subscription)
      : "-",
  }));
  // Add rows
   worksheet.addRows(formattedData);

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White bold
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" }, // Dark blue
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Export
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Manage_Invites.xlsx");
};

export default ExportInvitesExcel;


